import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { ActivatedRoute, Router } from "@angular/router"
import { MenuItem } from 'primeng/api';
import { LoginService } from 'src/app/service/login.service';
import { MessagesService } from 'src/app/service/messages.service';
import { Subscription } from 'rxjs';
import { WebsocketService } from 'src/app/service/websocketservice';
import { Chats } from 'src/app/interfaces/chatData';
import { SuscriptionService } from 'src/app/service/suscription.service';
import { Suscriptions } from 'src/app/interfaces/suscription.interface';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-chatheaderwincomp',
  templateUrl: './chatheaderwincomp.component.html',
  styleUrls: ['./chatheaderwincomp.component.scss']
})
export class ChatheaderwincompComponent implements OnInit, OnDestroy {
  private subscripciones: Subscription = new Subscription();

  private idCustomer: number;
  private esAdmin: boolean;
  private idUser: number;

  @Input() sh: boolean = false;
  @Input() dev: boolean = false;
  @Output() connModal: EventEmitter<any> = new EventEmitter();
  @Output() setModal: EventEmitter<any> = new EventEmitter();
  @Output() nchatModal: EventEmitter<any> = new EventEmitter();
  @Output() devModal: EventEmitter<any> = new EventEmitter();
  @Output() searchModal: EventEmitter<any> = new EventEmitter();
  items: MenuItem[] = [];
  nombreToken: string | null = '';

  constructor(private router: Router,
    private messagesservice: MessagesService, private webSocketService: WebsocketService,
    loginservice: LoginService, suscriptionService: SuscriptionService, private route: ActivatedRoute,
    private translate: TranslateService) {
    this.idCustomer = loginservice.chatCrmUser.idCustomer;
    this.idUser = loginservice.chatCrmUser.id;
    const idRol = loginservice.chatCrmUser.idRol;
    this.esAdmin = idRol === 1;

    this.subscripciones.add(
      loginservice.fechaObs.subscribe(fechaActual => {
        loginservice.compararTiempoSesion(fechaActual);
      })
    );
    this.subscripciones.add(
      this.messagesservice.dispositivo$().subscribe((data) => {
        if (data == null) {
          this.webSocketService.disconnect();
          this.nombreToken = ""
          return;
        }

        this.nombreToken = data.name == null || data.name === "" ? "Dispositivo Sin Nombre":data.name;
        const idSuscription = data.id.toString();
        const idCustomer = this.idCustomer.toString();
        const idUser = this.idUser.toString();

        suscriptionService.catalogoSuscripciones(this.idUser, idRol, true)
        .then(response => {
          const dispositivos: Suscriptions[] = response.data;
          if (dispositivos.length == 0) {
            this.messagesservice.setDispositivo(null);
            return;
          }
  
          const dispositivoEncontrado = data != undefined && data != null ?
                                        dispositivos.find(d => d.id == data.id) : null;
          if (dispositivoEncontrado == undefined || dispositivoEncontrado == null) {
            this.messagesservice.setDispositivo(null);
            return;
          }
  
          this.webSocketService.disconnect();
  
          if (this.esAdmin) {
            this.webSocketService.connect(idSuscription, idCustomer, '');
          } else {
            this.webSocketService.connect(idSuscription, idCustomer, idUser);
          }
        })
        .catch(err => {
          console.error("Error al conectar websocket por api de catalogos",err);
          setTimeout(()=>{this.redirectHome()}, 2000);
        })
      })
    );
    // Establecer idiomas disponibles y el idioma por defecto
    translate.addLangs(['en', 'es']);
    translate.setDefaultLang('es');
  }

  ngOnDestroy(): void {
    this.webSocketService.disconnect();
    this.subscripciones.unsubscribe();
  }
  
  ngOnInit(): void {
    // Obtener el parámetro 'lang' de la URL
    this.route.queryParams.subscribe(params => {
      const lang = params['lang'];
      if (lang) {
        this.translate.use(lang);
      } else {
        this.translate.use('es'); // Idioma por defecto
      }
    });
   }

  redirectHome(): void {
    this.router.navigate(['/dashboard'], {queryParamsHandling: 'merge'})
  }
  settingModal(): void {
    this.setModal.emit(true);
  }
  newChatsModal(): void {
    this.nchatModal.emit(true);
  }
  openCon(): void {
    this.connModal.emit(true);
  }
  showDevice(): void {
    this.devModal.emit(true);
  }
  chatsNew!: Chats[]
  openSearch(): void {
    this.searchModal.emit(true);
  }
}
